import React from 'react';
interface SectionHeadingProps {
  label?: string;
  title: string;
  intro?: string;
  id?: string;
  as?: 'h1' | 'h2';
  className?: string;
}
export function SectionHeading({
  label,
  title,
  intro,
  id,
  as = 'h2',
  className = ''
}: SectionHeadingProps) {
  const Heading = as;
  return <div className={className} data-id="element-492" data-mp="ryas25gakyeu">
      {label && <div className="flex items-center gap-3" data-id="element-493" data-mp="rxhvfxb1rpaf">
          <span className="h-[3px] w-10 bg-brand-red" aria-hidden="true" data-id="element-494" data-mp="mz6mdosktit9" />
          <span className="font-display text-sm font-semibold uppercase tracking-[0.2em] text-brand-light" data-id="element-495" data-mp="i7y9gis1ffbc">
            {label}
          </span>
        </div>}
      <Heading id={id} className="mt-4 font-display text-[40px] font-bold uppercase leading-[0.95] text-white md:text-[52px]" data-id="element-496" data-mp="d9epup0x2fm5">
        {title}
      </Heading>
      {intro && <p className="mt-5 max-w-2xl text-lg leading-relaxed text-steel-300" data-id="element-497" data-mp="47nhtdiwlwp4">{intro}</p>}
    </div>;
}